import { useApolloClient, useFragment } from "@apollo/client"

import { ProjectTypename } from "shared/types/Project"

import {
  ProjectFragment,
  ProjectFragmentDoc
} from "entities/projects/graphql/fragments.generated"

export function useProjectFragment(id: string) {
  const { cache } = useApolloClient()

  const { complete, data: project } = useFragment<ProjectFragment>({
    fragment: ProjectFragmentDoc,
    fragmentName: "Project",
    from: cache.identify({ id, __typename: ProjectTypename })
      ? { id, __typename: ProjectTypename }
      : null
  })

  return complete ? project : null
}
